<div *ngIf="cogs()">
  <div>
    <h2 class="page-details-title-style">COGS {{ cogs()?.id }}</h2>
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab label="General Info">
      <div class="filter__fields">
        <mat-card class="mat-elevation-z8">
          <mat-card-content>
            <mat-grid-list [cols]="2" gutterSize="10px" rowHeight="90">
              <mat-grid-tile>
                <read-only-form-field title="COGS ID" [value]="cogs()?.id?.toString()" testId="kt-cogs-id" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Trip Reference" [value]="cogs()?.tripReference" testId="kt-cogs-trip-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Product Type" [value]="cogs()?.productTypeName" testId="kt-cogs-product-type" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor" [value]="cogs()?.vendorName" testId="kt-cogs-vendor" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor Interface ID" [value]="cogs()?.vendorInterfaceId" testId="kt-cogs-vendor-interface-id" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Provider" [value]="cogs()?.providerVendorName" testId="kt-cogs-provider" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Confirmation Number" [value]="cogs()?.confirmationNumber" testId="kt-cogs-confirmation-number" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Sub-Vendor" [value]="cogs()?.subVendorName" testId="kt-cogs-sub-vendor" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Sub-Vendor Interface ID" [value]="cogs()?.subVendorInterfaceId" testId="kt-cogs-sub-vendor-interface-id" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Sub-Vendor Legal Entity" [value]="cogs()?.subVendorLegalEntity" testId="kt-cogs-sub-vendor-le" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Tour Agency" [value]="cogs()?.commissionAgencyName" testId="kt-cogs-tour-agency" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Tour Agency Parent" [value]="cogs()?.commissionAgencyParentName" testId="kt-cogs-tour-agency-parent" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Vendor Reference" [value]="cogs()?.vendorReference" testId="kt-cogs-vendor-ref" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Amount" [value]="cogs()?.amount?.toString()" testId="kt-cogs-amount" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Amount USD" [value]="cogs()?.amountUSD?.toString()" testId="kt-cogs-amount-usd" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Currency" [value]="cogs()?.currencyCode" testId="kt-cogs-currency" />
              </mat-grid-tile>
              <mat-grid-tile>
                <read-only-form-field title="Product ID" [value]="cogs()?.productId?.toString()" testId="kt-cogs-product-id" />
              </mat-grid-tile>
            </mat-grid-list>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
